import React, { FC, useContext, useEffect, useState } from "react";
import "./ColumnWeightInput.css"
import { BoardContext } from "../../../contexts/BoardContext";
import { IColumnDisplay } from "../../../common/api_interfaces/column/IColumnDisplay";

interface IColumnWeightInputProps {
    column?: IColumnDisplay;
    onEditWeight?: (weight: number) => void;
    onChangeWeight?: (weight: number) => void;
    edit: boolean;
}

const ColumnWeightInput: FC<IColumnWeightInputProps> = ({
    column,
    onEditWeight,
    onChangeWeight,
    edit,
}) => {
    const [maxWeight, setMaxWeight] = useState<number>(100);
    const [weight, setWeight] = useState<number>(column?.weight ?? 0);

    const boardContext = useContext(BoardContext);

    useEffect(() => {
        let maxW = 100;
        boardContext.columns.forEach((c) => {
            if (c.id !== column?.id) maxW -= c.weight ? c.weight : 0;
        });
        setMaxWeight(maxW);
    }, [boardContext.columns, column]);

    const handleChangeWeight = (e: any) => {
        const newWeight = Number(e.target.value);
        if (newWeight >= 0 && newWeight <= maxWeight) {
            setWeight(newWeight);
            if (onChangeWeight) onChangeWeight(newWeight);
        }
    };
    const onClickWeight = (e: any) => {
        const weight = Number(e.target.value);
        if (weight === 0 ) {
            e.target.value = ''
        }
    };

    return (
        <div className="weight-input-component">
            <div className="weight-input-component-name">
                Вес колонки
            </div>
            <div className="weight-input-component-input">
                <input
                    type="number"
                    min={0}
                    max={maxWeight}
                    onClick={onClickWeight}
                    value={weight}
                    onInput={handleChangeWeight}
                ></input> 
                {edit && onEditWeight ? (
                    <button onClick={() => onEditWeight(weight)}>
                        Изменить вес
                    </button>
                ) : null}
            </div>
        </div>
    );
};

export default ColumnWeightInput;
